import { Component, computed, input } from '@angular/core'

import { NgIcon, provideIcons } from '@ng-icons/core'
import { lucideCheck } from '@ng-icons/lucide'
import { hlm } from '@spartan-ng/brain/core'

import { HlmIconDirective } from '@yoshu-lib/ui/ui-icon-helm/src'

import type { ClassValue } from 'clsx'

@Component({
  selector: 'hlm-menu-item-check',
  providers: [provideIcons({ lucideCheck })],
  imports: [NgIcon, HlmIconDirective],
  template: `
    <!-- Using 1rem for size to mimick h-4 w-4 -->
    <ng-icon hlm size="1rem" name="lucideCheck" />
  `,
  host: {
    '[class]': '_computedClass()'
  }
})
export class HlmMenuItemCheckComponent {
  public readonly userClass = input<ClassValue>('', { alias: 'class' })
  protected _computedClass = computed(() =>
    hlm(
      'group-[.checked]:opacity-100 opacity-0 absolute left-2 flex h-3.5 w-3.5 items-center justify-center',
      this.userClass()
    )
  )
}
